export enum FlightsLocation {
  ORIGIN,
  DESTINATION
}

export const getTLAFromAirport = (location: string) => {
  const AIRPORT_CODE_LENGTH = 3;
  const NEGATIVE_INDEX_VALUE = -1;
  const OPEN_BRACKET = '(';
  const DASH_DELIMETER = '-';
  const LOCALIZED_DASH_DELIMETER = '–';
  const CLOSE_BRACKET = ')';
  const AIRPORT_CODE_REGEX = '[a-zA-Z]{3}';
  const indexOfOpenBracket = location.indexOf(OPEN_BRACKET);
  if (indexOfOpenBracket > NEGATIVE_INDEX_VALUE) {
    const parsedLocation = location.substring(indexOfOpenBracket + 1);
    let indexOfDash;
    if (parsedLocation.includes(DASH_DELIMETER)) {
      indexOfDash = parsedLocation.indexOf(DASH_DELIMETER);
    } else {
      indexOfDash = parsedLocation.indexOf(LOCALIZED_DASH_DELIMETER);
    }
    const indexOfClosedBracket = parsedLocation.indexOf(CLOSE_BRACKET);
    let endIndex;
    if (indexOfDash > NEGATIVE_INDEX_VALUE) {
      endIndex = indexOfDash;
    } else if (indexOfClosedBracket > NEGATIVE_INDEX_VALUE) {
      endIndex = indexOfClosedBracket;
    } else {
      parsedLocation.length;
    }
    const expectedAirportCode = parsedLocation.substring(0, endIndex).trim();
    if (expectedAirportCode.length === AIRPORT_CODE_LENGTH && expectedAirportCode.match(AIRPORT_CODE_REGEX)) {
      return expectedAirportCode;
    }
  }

  return null;
};
